var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiBexLogoLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 161,
    height: 36.963,
    viewBox: "0 0 161 36.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.796,
    y1: 0.19,
    x2: 0.071,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6af47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3869"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2469",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2469",
    transform: "translate(-779.999 -435.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2417",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2417",
    transform: "translate(822.051 443.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9755",
    "data-name": "\\u30D1\\u30B9 9755",
    d: "M13.57,76.992l6.06,13H7.415ZM0,100.65H2.326L6.64,91.639H20.405l4.313,9.011h2.326L13.618,72.384Z",
    transform: "translate(0 -72.384)",
    fill: "#fc9819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9756",
    "data-name": "\\u30D1\\u30B9 9756",
    d: "M24.3,74.707a1.751,1.751,0,0,1,1.91-1.666,1.682,1.682,0,1,1,0,3.333,1.751,1.751,0,0,1-1.91-1.666",
    transform: "translate(8.563 -72.212)",
    fill: "#fc9819"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_27261",
    "data-name": "\\u9577\\u65B9\\u5F62 27261",
    width: 2.121,
    height: 18.376,
    transform: "translate(33.71 9.89)",
    fill: "#fc9819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9757",
    "data-name": "\\u30D1\\u30B9 9757",
    d: "M36.022,73.042V84.434a11.464,11.464,0,0,1,8.956-3.8c6.886,0,11.082,4.373,11.082,9.981,0,5.7-4.253,10.359-11.194,10.359-5.654,0-8.173-3.041-8.845-3.992v3.469H33.784V73.042ZM53.712,90.613c0-5.322-4.142-8.175-8.844-8.175-4.478,0-8.958,2.71-8.958,8.079,0,4.847,3.135,8.65,8.9,8.65s8.9-3.8,8.9-8.554",
    transform: "translate(11.059 -72.211)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9758",
    "data-name": "\\u30D1\\u30B9 9758",
    d: "M57.849,89.411c0,4.942,4.255,8.172,9.068,8.172a8.876,8.876,0,0,0,7.95-4.419l1.9.951A11.261,11.261,0,0,1,66.75,99.39C59.64,99.39,55.5,94.923,55.5,89.269c0-6.748,5.486-10.219,11.085-10.219,6.157,0,10.8,4.183,10.8,10.361ZM75.034,87.6c-.56-3.849-3.919-6.748-8.452-6.748-4.647,0-7.95,2.993-8.566,6.748Z",
    transform: "translate(16.775 -70.629)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9759",
    "data-name": "\\u30D1\\u30B9 9759",
    d: "M83.522,88.608,75.07,79.389h2.742l7.222,7.984,7.108-7.984h2.744L86.6,88.608l9.18,10.169H93.039l-8.005-8.934-8.005,8.934H74.287Z",
    transform: "translate(23.166 -70.54)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2461",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2461",
    transform: "translate(779.999 435.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9760",
    "data-name": "\\u30D1\\u30B9 9760",
    d: "M73.61,8.655c-3.244-3.594-4.641-3.665-8.234-.42C68.97,4.99,69.041,3.594,65.8,0c3.244,3.594,4.641,3.665,8.234.42-3.594,3.245-3.665,4.641-.42,8.235",
    transform: "translate(-34.199 0)",
    fill: "#fc9819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9761",
    "data-name": "\\u30D1\\u30B9 9761",
    d: "M40.675,33.147c-5.489-4.229-5.971-9.771-6.442-12.7a10.266,10.266,0,0,0,4.291-2.693,8.627,8.627,0,0,0,2.086-4.265l-7.262.025.005,0A8.9,8.9,0,0,0,25.3,7.149C20.711,7,18.02,10.824,17.842,11.086A10.049,10.049,0,0,1,25.8,10.48a9.544,9.544,0,0,1,3.248,1.986,5.625,5.625,0,0,0-3.7,1.909,5.175,5.175,0,0,0-1.177,2.595l4.453-.144a5.342,5.342,0,0,0,1.3,3.27c-10.114-.058-17.711,3.888-18.778,8.827-.239,1.1-.905,5.161,1.784,7.761A10.263,10.263,0,0,0,16.365,38.8l10.154,0a9.522,9.522,0,0,1-2.809-.878,8.348,8.348,0,0,1-1.089-.711c-.021-.016-.12-.1-.228-.188-.822-.7-3.086-2.876-2.537-5.792.634-3.365,4.176-4.428,4.428-4.5a6.761,6.761,0,0,1,5.6,1.028,14.019,14.019,0,0,0,.323,1.76A16.994,16.994,0,0,0,36.846,38.8l11.742-1.834a23.92,23.92,0,0,1-7.913-3.816M32.736,15.33a.844.844,0,1,1-.842.844.843.843,0,0,1,.842-.844m2.391,16.5A13.779,13.779,0,0,1,32.484,20.9a17.636,17.636,0,0,0,3.574,10.7,19.808,19.808,0,0,0,5.864,5.132,15.879,15.879,0,0,1-6.794-4.9",
    transform: "translate(-10.889 -1.836)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBexLogoLong);
export default __webpack_public_path__ + "static/media/ai-bex-logo-long.99abbda9010daf1d4c1696e62dad1771.svg";
export { ForwardRef as ReactComponent };